import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { containerWidthHOC } from '@mq/voltron-parent';
import { Container, Row, Col } from '@mqd/volt-base';
import { UAM_GRANULAR_PERMISSIONS } from '@mqd/mqd-constants';

import BeneficialOwnerCard from './BeneficialOwnerCard';

import { SUCCESS } from './../constants';

const { BUSINESS_DETAILS_VIEW_AND_EDIT } = UAM_GRANULAR_PERMISSIONS;

class BeneficialOwnersTab extends Component {
  renderBeneficialOwnerCard(
    beneficialOwner,
    cardTitle,
    colSpan,
    businessStore,
    updateEditable,
    canRevealIdentification,
    uamGranularPermissionsActive
  ) {
    return (
      <Col span={colSpan}>
        <BeneficialOwnerCard
          beneficialOwner={beneficialOwner}
          cardTitle={cardTitle}
          businessStore={businessStore}
          editable={updateEditable}
          canRevealIdentification={canRevealIdentification}
          uamGranularPermissionsActive={uamGranularPermissionsActive}
        />
      </Col>
    );
  }

  render() {
    let { businessStore = {}, containerWidth, canRevealIdentification, userStore } = this.props;

    const {
      hasRoleInArrayForActiveProgram = () => {},
      redseaRoles,
      uamGranularPermissionsActive,
    } = userStore;

    const {
      updateBusinessAllowedRoles,
      businessIdentityStatus,
      beneficial_owner1,
      beneficial_owner2,
      beneficial_owner3,
      beneficial_owner4,
    } = businessStore || {};

    let colSpan = 6;
    if (containerWidth <= 800) {
      colSpan = 12;
    }

    let updateEditable =
      businessStore &&
      hasRoleInArrayForActiveProgram(updateBusinessAllowedRoles) &&
      (businessIdentityStatus === SUCCESS || businessIdentityStatus === '');

    if (uamGranularPermissionsActive) {
      const hasViewAndEditPermissions = redseaRoles.includes(BUSINESS_DETAILS_VIEW_AND_EDIT);

      updateEditable = hasViewAndEditPermissions;
    }

    return (
      <div>
        <Container>
          <Row>
            {this.renderBeneficialOwnerCard(
              beneficial_owner1,
              'Beneficial Owner 1',
              colSpan,
              businessStore,
              updateEditable,
              canRevealIdentification,
              uamGranularPermissionsActive
            )}
            {this.renderBeneficialOwnerCard(
              beneficial_owner2,
              'Beneficial Owner 2',
              colSpan,
              businessStore,
              updateEditable,
              canRevealIdentification,
              uamGranularPermissionsActive
            )}
            {this.renderBeneficialOwnerCard(
              beneficial_owner3,
              'Beneficial Owner 3',
              colSpan,
              businessStore,
              updateEditable,
              canRevealIdentification,
              uamGranularPermissionsActive
            )}
            {this.renderBeneficialOwnerCard(
              beneficial_owner4,
              'Beneficial Owner 4',
              colSpan,
              businessStore,
              updateEditable,
              canRevealIdentification,
              uamGranularPermissionsActive
            )}
          </Row>
        </Container>
      </div>
    );
  }
}

BeneficialOwnersTab.propTypes = {
  businessStore: PropTypes.any,
  canRevealIdentification: PropTypes.bool,
  userStore: PropTypes.any,
};

BeneficialOwnersTab.defaultProps = {
  businessStore: null,
  canRevealIdentification: false,
  userStore: {},
};

export default containerWidthHOC(observer(BeneficialOwnersTab));
